import React, { useState } from 'react'
import { Box, Link } from '@material-ui/core'

import { Dropzone } from 'Components/Form/Dropzone'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { processCsvFile } from '../../../../Utils/Misc'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import {
  getCampaigns as getCampaignsGQL,
  addFlyerCodes,
} from '../../../../Module/graphQL'

import {
  formatFlyerCodesData,
  formatFlyerCodesGQLData,
  downloadFlyerCodesTemplate,
  validateCsvFlyerCodesData,
} from '../util'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'

const AddCsvFlyerCodesModal = props => {
  const [flyersData, setFlyersData] = useState(null)

  const { csvModalCancel, showReduxModal, hideReduxModal } = props
  const { data = {}, isLoaded } = useGraphQLFetch({
    fetchFn: getCampaignsGQL,
    mapResponse: formatFlyerCodesGQLData,
  })

  const onError = err => {
    showReduxModal({
      title: 'Upload failed',
      children: `${err}`,
      confirmLabel: `OK`,
      hideCancel: true,
    })
  }

  const modalConfirmHandler = async () => {
    if (flyersData) {
      showReduxModal({
        title: 'Confirmation needed',
        children: (
          <ConfirmationModalBody
            flyersData={flyersData}
            hideReduxModal={hideReduxModal}
            addFlyerCodes={addFlyerCodes}
            csvModalCancel={csvModalCancel}
          />
        ),
        confirmLabel: `Confirm`,
        hideButtons: true,
      })
    }
  }

  const onLoadFile = async entryFiles => {
    try {
      if (entryFiles) {
        const csvData = await processCsvFile(entryFiles[0])

        if (!csvData || !csvData.data) return
        validateCsvFlyerCodesData(csvData.data, data)

        const formatSendData = formatFlyerCodesData(csvData.data, data)

        setFlyersData(formatSendData)
      }
    } catch (err) {
      onError(err)
      console.error(err)
    }
  }

  return (
    <Modal show={true}>
      <ModalHeader>
        <ModalTitle>Import Flyer Codes</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Box display="flex" alignItems="center" flexDirection="column">
          <Link onClick={downloadFlyerCodesTemplate}>
            Download the csv template
          </Link>
          {isLoaded ? (
            <Dropzone
              mainLabel="Flyer Codes File"
              input={{
                value: '',
                onChange: onLoadFile,
              }}
            />
          ) : (
            'Preparing data, please wait...'
          )}
        </Box>
      </ModalBody>
      <ModalFooter>
        <SubmitButton
          value="cancel"
          onClick={csvModalCancel}
          disabled={false}
        />
        <SubmitButton
          value={'Confirm'}
          onClick={modalConfirmHandler}
          disabled={!isLoaded}
        />
      </ModalFooter>
    </Modal>
  )
}

const ConfirmationModalBody = ({
  hideReduxModal,
  csvModalCancel,
  flyersData,
}) => {
  const [isLoading, setLoading] = useState(false)

  const onConfirm = async () => {
    try {
      setLoading(true)
      await addFlyerCodes(null, flyersData)
      setLoading(false)
      hideReduxModal()
      csvModalCancel()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <section className="redux-modal">
      {isLoading ? (
        <LoadingIndicator
          label={`Uploading ${Number(
            flyersData.length,
          ).toLocaleString()} codes...`}
        />
      ) : (
        <article>
          <p>
            Are you sure? If you get this wrong you'll have to adjust{' '}
            <b style={{ fontSize: 'large' }}>
              {Number(flyersData.length).toLocaleString()}
            </b>{' '}
            flyer codes manually.
          </p>
        </article>
      )}
      <ModalFooter>
        <SubmitButton value="Cancel" onClick={hideReduxModal} />
        <SubmitButton
          disabled={isLoading}
          value="Confirm"
          onClick={onConfirm}
          formSubmitting={isLoading}
        />
      </ModalFooter>
    </section>
  )
}
export default AddCsvFlyerCodesModal



// WEBPACK FOOTER //
// ./src/Containers/Header/Modals/AddCsvFlyerCodesModal/index.js